
            const data = {"name":"burger-circles","data":{"width":"4","height":"16","viewBox":"0 0 4 16","data":"<path pid=\"0\" d=\"M2 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\" _fill=\"#000\"/>","originalColors":[{"type":"fill","color":"#000"}],"stopColors":[]}}
        
                module.exports = data
                